module.exports = __webpack_public_path__ + "static/img/apply_header_02_zh.c580ae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apply_header_02_zh.png
// module id = 9JuQ
// module chunks = 34